export const TOKEN_KEY = "access_token";
export const REFRESH_KEY = "refresh_token";
export const USER_KEY = "user";

export const login = ({ accessToken, refreshToken, user }) => {
  localStorage.setItem(TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_KEY, refreshToken);
  localStorage.setItem(USER_KEY, JSON.stringify(user));

  // 🔔 notify app
  window.dispatchEvent(new Event("auth-change"));
};

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem("session_id");

  // 🔔 notify app
  window.dispatchEvent(new Event("auth-change"));
};

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem("token");
  localStorage.removeItem("session_id");
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY));
  } catch {
    return null;
  }
};

/* ✅ REQUIRED BY HEADER */
export const isLoggedIn = () => {
  return !!localStorage.getItem(TOKEN_KEY);
};

export const getAnyToken = () => {
  return (
    localStorage.getItem(TOKEN_KEY) || // access_token
    localStorage.getItem("token") // legacy token
  );
};

/**
 * Save token in BOTH places (safe, backward compatible)
 */
export const setAnyToken = (token) => {
  if (!token) return;

  localStorage.setItem(TOKEN_KEY, token); // access_token
  localStorage.setItem("token", token); // legacy token

  window.dispatchEvent(new Event("auth-change"));
};

/**
 * Remove token from BOTH places
 */
export const clearAnyToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem("token");
  localStorage.removeItem("session_id");
};
